import React, { Component } from 'react'
import { withStyles, Button, Card, CardContent, Grid, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, CardHeader } from '@material-ui/core';
import { GetData, PostData } from '../../../api/service';
import ReactToPrint from 'react-to-print';
import ViewTableModified from './ViewTableModified';
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import ViewTableModifiedPostAdmission from './ViewTableModifiedPostAdmission';

const styles = theme => ({
    formControl: {
        width: '100%'
    }
})

class PostAdmissionData extends Component {

    state = {
        course: '',
        stream: '',
        course_type: '',
        semester: '',
        caste: '',
        data: [],
        isLoaded: false,
        subjects: [],
        isSubjectLoaded: false,
        sub_code: '',
        sub_name: '',

    }

    buttonRef = React.createRef();

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if (e.target.name === 'course' || e.target.name === 'stream' || e.target.name === 'course_type') {
                let course_type = this.state.course_type;
                if(course_type == ''){
                    course_type = 'NONE'
                }
                this.getSubjects(this.state.course, this.state.stream, course_type)
            }
        })

        if (e.target.name === 'sub_code') {
            let subjects = this.state.subjects;

            let r = subjects.filter(el => el.sub_code === e.target.value)
            if (Array.isArray(r) && r.length > 0) {
                this.setState({
                    sub_name: r[0].sub_name
                })
            }
        }
    }

    getSubjects = (course, stream, course_type) => {
        if (course !== '' && stream !== '') {
            let course_type = 'NONE';
            GetData(`/${course}/${stream}/${course_type}/getadmissionsubjectbytype`)
                .then((resp) => {
                    //console.log(resp)
                    this.setState({
                        subjects: resp,
                        isSubjectLoaded: true
                    })

                })

        }
    }

    onSubmit = (e) => {
        e.preventDefault();

        let course_type = '';
        let sub_code = '';

        if (this.state.course === 'TDC') {
            course_type = this.state.course_type
        }

        let d = {
            course: this.state.course,
            stream: this.state.stream,
            course_type: course_type,
            sub_code : this.state.sub_code,
            semester: this.state.semester
        }

        PostData(`/admission/getadmittedstudents`, d)
            .then((resp) => {
                //console.log(resp);
                this.setState({
                    data: resp,
                    isLoaded: true
                })
            })
    }

    setTable = (name, value) => {

        this.setState({
            [name]: value
        })
    }


    render() {
        let { classes } = this.props;

        let i = [];
        if (this.state.isSubjectLoaded) {
            let subjects = this.state.subjects;
            i = subjects.map((el, index) =>
                <MenuItem key={index} value={el.sub_code}>{el.sub_name} - {el.sub_code}</MenuItem>
            )
        }
        return (
            <div>
                <form onSubmit={this.onSubmit}>
                    <Card>
                        <CardHeader
                            title={`Admission List View - Both Online and Offline`}
                            subheader={`List of all student data - both online and offline`}
                        />
                        <CardContent>

                            <Grid container spacing={16}>
                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                    <FormControl required variant="outlined" className={classes.formControl}>
                                        <InputLabel htmlFor="outlined-age-simple">
                                            Course
                                        </InputLabel>
                                        <Select
                                            name="course"
                                            value={this.state.course}
                                            onChange={this.onChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="course" />
                                            }
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>

                                            <MenuItem value="HS">HS</MenuItem>
                                            <MenuItem value="TDC">TDC</MenuItem>
                                            <MenuItem value="PG">PG</MenuItem>
                                            <MenuItem value="BSC-BIOTECHNOLOGY">BSC-BioTechnology</MenuItem>
                                            <MenuItem value="BCA">BCA</MenuItem>


                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                    <FormControl required variant="outlined" className={classes.formControl}>
                                        <InputLabel htmlFor="outlined-age-simple">
                                            Stream
                                        </InputLabel>
                                        <Select
                                            name="stream"
                                            value={this.state.stream}
                                            onChange={this.onChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="stream" />
                                            }
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value="ARTS">ARTS</MenuItem>
                                            <MenuItem value="SCIENCE">SCIENCE</MenuItem>
                                            <MenuItem value="COMMERCE">COMMERCE</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Grid>

                                {this.state.course === 'TDC' ? (<Grid item lg={3} md={3} sm={12} xs={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel htmlFor="outlined-age-simple">
                                            Course Type
                                        </InputLabel>
                                        <Select
                                            name="course_type"
                                            value={this.state.course_type}
                                            onChange={this.onChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="course_type" />
                                            }
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value="HONOURS">HONOURS</MenuItem>
                                            <MenuItem value="REGULAR">REGULAR</MenuItem>
                                            <MenuItem value="MAJOR">MAJOR</MenuItem>
                                            <MenuItem value="GENERAL">GENERAL</MenuItem>


                                        </Select>
                                    </FormControl>
                                </Grid>) : null}


                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                    <FormControl required variant="outlined" className={classes.formControl}>
                                        <InputLabel htmlFor="outlined-age-simple">
                                            {this.state.course == 'TDC' ? 'Semester' : 'Year'}
                                        </InputLabel>
                                        <Select
                                            name="semester"
                                            value={this.state.semester}
                                            onChange={this.onChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="semester" />
                                            }
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value="1">1</MenuItem>
                                            <MenuItem value="2">2</MenuItem>
                                            <MenuItem value="3">3</MenuItem>
                                            <MenuItem value="4">4</MenuItem>
                                            <MenuItem value="5">5</MenuItem>
                                            <MenuItem value="6">6</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                   <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel htmlFor="outlined-age-simple">
                                            Subject
                    </InputLabel>
                                        <Select
                                            name="sub_code"
                                            value={this.state.sub_code}
                                            onChange={this.onChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="sub_code" />
                                            }
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {i}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                        </CardContent>

                        <CardActions style={{ justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                            >
                                Submit
                                        </Button>
                        </CardActions>
                    </Card>
                </form>

                <br />




                {this.state.isLoaded ?
                    (<Card>
                        <CardContent style={{ textAlign: 'center' }}>
                            <ReactToPrint
                                trigger={() =>
                                    <Button
                                        variant="outlined"
                                        color="primary"

                                    >
                                        Print
                        </Button>
                                }
                                ref={el => this.buttonRef = el}
                                content={() => this.componentRef}
                                pageStyle={{ margin: '10px' }}
                                copyStyles={true}
                            />
                            &nbsp;&nbsp;

                            <ReactHTMLTableToExcel
                                id="test-table-xls-button"
                                className="download-table-xls-button"
                                table="table-to-xls"
                                filename={`Reports`}
                                sheet="tablexls"
                                className={classes.button}
                                buttonText="Download as XLS" />
                            
                        </CardContent>
                        <CardContent>
                            <ViewTableModifiedPostAdmission
                                ref={el => (this.componentRef = el)}
                                data={this.state.data}
                                {...this.state}
                            />
                        </CardContent>

                    </Card>)
                    : null}
            </div>
        )
    }
}

export default withStyles(styles)(PostAdmissionData)